// Announcements data with slugs for SEO-friendly URLs
import progenxTetz1 from '../assets/images/progenx_tetz_1.jpg';
import progenxTetz2 from '../assets/images/progenx_tetz_2.jpg';
import progenxTetz3 from '../assets/images/progenx_tetz_3.jpg';
import progenxTetz4 from '../assets/images/progenx_tetz_4.jpg';
import progenxTetz5 from '../assets/images/progenx_tetz_5.jpg';
import teknogirisimRozeti from '../assets/images/Teknogirisim-Rozeti.jpg';
import awsActivate from '../assets/images/aws-activate.jpg';
import tetz2025_1 from '../assets/images/tetz2025_1.jpg';
import tetz2025_2 from '../assets/images/tetz2025_2.jpg';
import tetz2025_3 from '../assets/images/tetz2025_3.jpg';
import tetz2025_4 from '../assets/images/tetz2025_4.jpg';
import tetz2025_5 from '../assets/images/tetz2025_5.jpg';
import tetz2025_6 from '../assets/images/tetz2025_6.jpg';
import tetz2025_7 from '../assets/images/tetz2025_7.jpg';
import tetz2025_8 from '../assets/images/tetz2025_8.jpg';
import tetz2025_9 from '../assets/images/tetz2025_9.jpg';
import tetz2025_10 from '../assets/images/tetz2025_10.jpg';
import tetz2025_11 from '../assets/images/tetz2025_11.jpg';
// Take Off İstanbul images (imported from assets/images folder like TETZ)
import takeoff1 from '../assets/images/takeoff1.jpg';
import takeoff2 from '../assets/images/takeoff2.jpg';
import takeoff3 from '../assets/images/takeoff3.jpg';
import takeoff4 from '../assets/images/takeoff4.jpg';
import takeoff5 from '../assets/images/takeoff5.jpg';
import takeoff6 from '../assets/images/takeoff6.jpg';
import takeoff7 from '../assets/images/takeoff7.jpg';
// BETT UK 2026 images
import bett1 from '../assets/images/bett1.jpg';
import bett2 from '../assets/images/bett2.jpg';
import bett3 from '../assets/images/bett3.jpg';
import bett4 from '../assets/images/bett4.jpg';
import bett5 from '../assets/images/bett5.jpg';
import bett6 from '../assets/images/bett6.jpg';
// ETKİM Bakan Ziyareti images
import etkimBakanZiyareti from '../assets/images/etkim-bakan-ziyareti.jpg';

const tetzImages = [
  tetz2025_1, tetz2025_2, tetz2025_3, tetz2025_4, tetz2025_5,
  tetz2025_6, tetz2025_7, tetz2025_8, tetz2025_9, tetz2025_10, tetz2025_11
];

const takeoffImages = [
  takeoff1, takeoff2, takeoff3, takeoff4, takeoff5, takeoff6, takeoff7
];

const bettImages = [
  bett1, bett2, bett3
];

const bettVisitImages = [
  bett4, bett5, bett6
];

const etkimBakanImages = [
  etkimBakanZiyareti
];

export const announcements = [
  {
    id: 'etkim-bakan-ziyareti',
    slug: 'etkim-bakan-yusuf-tekin-ziyareti',
    title: 'Millî Eğitim Bakanı Prof. Dr. Yusuf Tekin\'in ETKİM Ziyareti',
    date: 'Şubat 2026',
    excerpt: 'Millî Eğitim Bakanımız Sayın Prof. Dr. Yusuf Tekin\'in teşrifleriyle, "Eğitim Teknolojileri Ekosistem Buluşması" ETKİM ev sahipliğinde gerçekleştirildi.',
    content: `📢 <strong>Millî Eğitim Bakanımız Sayın Prof. Dr. Yusuf Tekin'in teşrifleriyle</strong>, "Eğitim Teknolojileri Ekosistem Buluşması" ETKİM ev sahipliğinde gerçekleştirildi.

Etkinlik kapsamında Sayın Bakanımız ile ProgenX'in çalışmalarını, eğitim teknolojilerindeki yenilikçi yaklaşımımızı ve ülkemizin eğitim sistemine sunabileceğimiz olası katkıları paylaşma fırsatı bulduk.

ProgenX olarak geliştirdiğimiz yapay zekâ destekli çözümler, dijital öğrenme ekosistemimiz ve öğrenci–öğretmen odaklı vizyonumuz hakkında kapsamlı bir değerlendirme yapıldı.

Ziyaretleri ve kıymetli değerlendirmeleri için <strong>Sayın Bakanımız Prof. Dr. Yusuf Tekin</strong>'e teşekkür ederiz.

ProgenX olarak, ülkemizin eğitim vizyonuna katkı sunma hedefiyle çalışmalarımızı sürdürmeye devam edeceğiz.`,
    images: etkimBakanImages,
    links: [
      { text: 'Instagram\'da paylaşımı görüntüle', url: 'https://www.instagram.com/p/DUV6dbHDJMx/' },
      { text: 'LinkedIn\'de paylaşımı görüntüle', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7424846851989860354/' },
      { text: 'ETKİM MEB LinkedIn Paylaşımı', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7425192077405286400/' },
      { text: 'Yeni Şafak Haberi', url: 'https://www.yenisafak.com/gundem/bakan-tekin-teknolojiye-dair-her-adimi-genis-yelpazeyle-tartmak-durumundayiz-4793986' },
      { text: 'Hürriyet Haberi', url: 'http://hurriyet.com.tr/egitim/bakan-tekin-genc-girisimcilerle-bulustu-43099255#' },
      { text: 'Bursa MEB Haberi', url: 'https://bursa.meb.gov.tr/www/bakan-tekin-egitim-teknolojileri-etkim-ekosistem-bulusmasina-katildi/icerik/5966/tr' }
    ],
    tags: ['MEB', 'YusufTekin', 'ProgenX', 'EdTech', 'Eğitim', 'EğitimTeknolojileri', 'YapayZekâ', 'EğitimdeYenilik', 'ETKİM'],
    isHighlighted: true,
    category: 'Etkinlik',
    faqs: [
      {
        question: 'ETKİM Ekosistem Buluşması nedir?',
        answer: 'ETKİM (Eğitim Teknolojileri Kuluçka ve İnovasyon Merkezi) ev sahipliğinde gerçekleştirilen "Eğitim Teknolojileri Ekosistem Buluşması", eğitim teknolojileri alanındaki paydaşları bir araya getiren önemli bir etkinliktir.'
      },
      {
        question: 'Bakan ziyareti kapsamında neler değerlendirildi?',
        answer: 'Etkinlik kapsamında Sayın Bakanımız ile ProgenX\'in çalışmaları, eğitim teknolojilerindeki yenilikçi yaklaşımımız, yapay zekâ destekli çözümlerimiz, dijital öğrenme ekosistemimiz ve öğrenci–öğretmen odaklı vizyonumuz hakkında kapsamlı bir değerlendirme yapıldı.'
      }
    ]
  },
  {
    id: 'bett-uk-ziyaret',
    slug: 'bett-uk-bakan-yardimcisi-ziyareti',
    title: 'BETT UK\'te Bakan Yardımcısı ve Genel Müdür Ziyareti',
    date: 'Ocak 2026',
    excerpt: 'BETT UK fuarında, Millî Eğitim Bakanlığı Bakan Yardımcısı Sayın M. Bilal Macit ve Millî Eğitim Bakanlığı Yenilik ve Eğitim Teknolojileri Genel Müdürü Sayın Mustafa Canlı, ProgenX standımızı ziyaret etti.',
    content: `📢 <strong>BETT UK fuarında, Millî Eğitim Bakanlığı Bakan Yardımcısı Sayın M. Bilal Macit</strong> ve <strong>Millî Eğitim Bakanlığı Yenilik ve Eğitim Teknolojileri Genel Müdürü Sayın Mustafa Canlı</strong>, ProgenX standımızı ziyaret etti.

Ziyaret kapsamında;
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Eğitim teknolojilerinde yenilikçi yaklaşımımızı,</li>
  <li style="margin-bottom: 10px;">• Yapay zekâ destekli çözüm ve ürünlerimizi,</li>
  <li style="margin-bottom: 10px;">• Türkiye'de eğitime sunabileceğimiz katkıları,</li>
  <li style="margin-bottom: 10px;">• Millî Eğitim Bakanlığı ile gerçekleştirilebilecek olası iş birliklerini,</li>
  <li style="margin-bottom: 10px;">• Öğrenci, öğretmen ve kurum odaklı geliştirdiğimiz dijital öğrenme ekosistemimizi</li>
</ul>
değerlendirme fırsatı bulduk.

ProgenX olarak, ülkemizin eğitim vizyonuna katkı sunmak ve geleceğin öğrenme deneyimini şekillendirmek için çalışmaya devam ediyoruz.

Ziyaretleri ve değerli değerlendirmeleri için <strong>Sayın M. Bilal Macit</strong> ve <strong>Sayın Mustafa Canlı</strong>'ya teşekkür ederiz.`,
    images: bettVisitImages,
    links: [
      { text: 'LinkedIn\'de paylaşımı görüntüle', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7421592922778898432/' }
    ],
    tags: ['ProgenX', 'BETTUK2026', 'AIinEducation', 'EdTechInnovation', 'TurkishEducation', 'FutureOfLearning', 'MEB', 'ETKİM'],
    isHighlighted: true,
    category: 'Etkinlik',
    faqs: [
      {
        question: 'BETT UK\'te hangi yetkililer ProgenX standını ziyaret etti?',
        answer: 'BETT UK fuarında, Millî Eğitim Bakanlığı Bakan Yardımcısı Sayın M. Bilal Macit ve Millî Eğitim Bakanlığı Yenilik ve Eğitim Teknolojileri Genel Müdürü Sayın Mustafa Canlı, ProgenX standımızı ziyaret etti.'
      },
      {
        question: 'Ziyaret kapsamında neler değerlendirildi?',
        answer: 'Ziyaret kapsamında eğitim teknolojilerinde yenilikçi yaklaşımımız, yapay zekâ destekli çözüm ve ürünlerimiz, Türkiye\'de eğitime sunabileceğimiz katkılar, Millî Eğitim Bakanlığı ile gerçekleştirilebilecek olası iş birlikleri ve öğrenci, öğretmen ve kurum odaklı geliştirdiğimiz dijital öğrenme ekosistemimiz değerlendirildi.'
      }
    ]
  },
  {
    id: 'bett-uk-2026',
    slug: 'bett-uk-2026-dayiz',
    title: 'BETT UK 2026\'dayız!',
    date: 'Ocak 2026',
    excerpt: 'ProgenX Eğitim ve Bilişim Teknolojileri A.Ş. olarak Londra\'da, Millî Eğitim Bakanlığı pavilyonunda ülkemizi temsil ediyoruz.',
    content: `📢 <strong>BETT UK 2026'dayız!</strong><br>
ProgenX Eğitim ve Bilişim Teknolojileri A.Ş. olarak Londra'da, Millî Eğitim Bakanlığı pavilyonunda ülkemizi temsil ediyoruz.

Dünyanın en büyük eğitim teknolojileri fuarlarından biri olan BETT UK'te, ProgenX olarak geliştirdiğimiz yenilikçi EdTech çözümlerini uluslararası arenada paylaşmaktan büyük gurur duyuyoruz.

Fuarda; yapay zekâ destekli eğitim teknolojilerimizi dünyanın dört bir yanından gelen eğitimciler, kamu temsilcileri, teknoloji liderleri ve sektör profesyonelleriyle buluşturuyoruz.
Standımızda hem Türkiye'nin EdTech vizyonunu hem de ProgenX'in geliştirdiği teknolojik yenilikleri uluslararası düzeyde aktarmaya bugün itibariyle başlıyoruz.

21-22-23 Ocak tarihleri arasında 3 gün gerçekleştirilecek olan fuarda siz değerli katılımcılarımızı standımızda bekliyoruz.`,
    images: bettImages,
    links: [
      { text: 'LinkedIn\'de paylaşımı görüntüle (Türkçe)', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7419671626599849985/' },
      { text: 'LinkedIn\'de paylaşımı görüntüle (English)', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7419800432224686080/' }
    ],
    tags: ['BETT2026', 'ProgenX', 'EğitimTeknolojileri', 'EdTechTürkiye', 'YapayZekâ', 'DijitalEğitim', 'EğitimdeDönüşüm', 'TeknolojiveEğitim', 'EğitimdeYenilik', 'StartupTürkiye', 'Girişimcilik', 'ArGe', 'YenilikçiÇözümler', 'DijitalDönüşüm'],
    isHighlighted: true,
    category: 'Etkinlik',
    faqs: [
      {
        question: 'BETT UK 2026 nedir?',
        answer: 'BETT UK, dünyanın en büyük eğitim teknolojileri fuarlarından biridir. ProgenX olarak bu fuarda Millî Eğitim Bakanlığı pavilyonunda ülkemizi temsil ediyoruz ve yenilikçi EdTech çözümlerimizi uluslararası arenada paylaşıyoruz.'
      },
      {
        question: 'BETT UK 2026\'da neler yapıyorsunuz?',
        answer: 'Fuarda yapay zekâ destekli eğitim teknolojilerimizi dünyanın dört bir yanından gelen eğitimciler, kamu temsilcileri, teknoloji liderleri ve sektör profesyonelleriyle buluşturuyoruz. Standımızda hem Türkiye\'nin EdTech vizyonunu hem de ProgenX\'in geliştirdiği teknolojik yenilikleri uluslararası düzeyde aktarıyoruz.'
      }
    ]
  },
  {
    id: 'takeoff-istanbul-2025',
    slug: 'take-off-istanbul-2025',
    title: 'Take Off İstanbul 2025\'te Yer Aldık!',
    date: 'Ocak 2025',
    excerpt: 'Take Off İstanbul 2025\'in 2. gününü yoğun ilgi ve değerli karşılaşmalarla tamamladık! Standımıza uğrayıp ProgenX çözümlerimizi yakından inceleyen tüm yerli ve yabancı katılımcılara teşekkür ederiz.',
    content: `Take Off İstanbul 2025'in 2. gününü yoğun ilgi ve değerli karşılaşmalarla tamamladık! 🚀

Standımıza uğrayıp <strong>ProgenX</strong> çözümlerimizi yakından inceleyen tüm yerli ve yabancı katılımcılara teşekkür ederiz.

Bugün ayrıca <strong>YEĞİTEK Ar-Ge ve Ekosistem Daire Başkanı Sayın Dr. Bilgehan Özbaylanlı</strong>'nın sunumuna katılım sağlama fırsatı bulduk; kendilerine ilham verici paylaşımları için teşekkür ederiz.

Etkinlik kapsamında <strong>TRT Türk</strong> ile bir röportaj gerçekleştirdik.
ProgenX'i daha yakından tanımak isterseniz, cumartesi günü yayınlanacak bu bölümü izlemenizi mutlaka öneririz.

Take Off 2025 sona erdi — bir sonraki etkinlikte görüşmek üzere!`,
    images: takeoffImages,
    links: [
      { text: 'LinkedIn\'de paylaşımı görüntüle', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7404893587869626368/?updateEntityUrn=urn%3Ali%3Afs_updateV2%3A%28urn%3Ali%3Aactivity%3A7404893587869626368%2CFEED_DETAIL%2CEMPTY%2CDEFAULT%2Cfalse%29' }
    ],
    tags: ['TakeOffIstanbul2025', 'TakeOffIstanbul', 'TakeOff2025', 'EdTech', 'Innovation', 'Startup', 'ProgenX', 'Etkim', 'Yeğitek', 'MEB', 'Entrepreneurship', 'GlobalStartups'],
    isHighlighted: true,
    category: 'Etkinlik',
    faqs: [
      {
        question: 'Take Off İstanbul 2025 nedir?',
        answer: 'Take Off İstanbul, girişimciler, yatırımcılar ve teknoloji şirketlerini bir araya getiren uluslararası bir etkinliktir. ProgenX olarak bu etkinlikte yer aldık ve çözümlerimizi tanıtma fırsatı bulduk.'
      },
      {
        question: 'Take Off İstanbul 2025\'te neler yaptınız?',
        answer: 'Etkinlikte standımızda ProgenX çözümlerimizi tanıttık, YEĞİTEK Ar-Ge ve Ekosistem Daire Başkanı Dr. Bilgehan Özbaylanlı\'nın sunumuna katıldık ve TRT Türk ile bir röportaj gerçekleştirdik.'
      }
    ]
  },
  {
    id: 'tetz2025-sonuc-raporu',
    slug: 'tetz-2025-sonuc-raporunda-yer-aldik',
    title: 'TETZ 2025 Sonuç Raporunda Yer Aldık!',
    date: '10 Eylül 2025',
    excerpt: 'Türkiye Eğitim Teknolojileri Zirvesi 2025\'in (TETZ 2025) yayımlanan sonuç raporunda, Progenx olarak biz de yer aldık!',
    content: `📢 <strong>Büyük Bir Gururu Paylaşıyoruz!</strong><br>
Türkiye Eğitim Teknolojileri Zirvesi 2025'in (TETZ 2025) yayımlanan sonuç raporunda, Progenx olarak biz de yer aldık! ✨

Cumhurbaşkanımız <strong>Sayın Recep Tayyip Erdoğan</strong> ve Millî Eğitim Bakanımız <strong>Sayın Yusuf Tekin</strong>'in teşrifleriyle gerçekleşen zirvede, Türkiye'nin eğitim teknolojileri vizyonuna yön veren aktörlerden biri olarak raporda yer almak bizim için çok değerli.

Bu kıymetli raporda yer almak; öğrenciler, öğretmenler ve kurumlar için geliştirdiğimiz yenilikçi, kapsayıcı ve sürdürülebilir eğitim teknolojisi çözümlerimizin bir yansımasıdır.

👉 Progenx olarak, Türkiye'nin dijital eğitim ekosistemine katkı sunmaya ve geleceğin öğrenme deneyimlerini şekillendirmeye devam edeceğiz.`,
    images: [progenxTetz1, progenxTetz2, progenxTetz3, progenxTetz4, progenxTetz5],
    links: [
      { text: 'Instagram\'da görüntüle', url: 'https://www.instagram.com/p/DObBf5YDD2s/?img_index=1' },
      { text: 'LinkedIn\'de görüntüle', url: 'https://www.linkedin.com/posts/progenx-academy_tetz2025-progenx-eafbitimdedijitaldaemnaesagnaesm-activity-7371526732480352256-m0_i?utm_source=share&utm_medium=member_desktop&rcm=ACoAADQNWksBq5IQ2T_4LmMx5QCoxnhqLwhbkRg' }
    ],
    tags: ['TETZ2025', 'Progenx', 'EğitimdeDijitalDönüşüm', 'EdTech', 'Türkiye', 'Eğitim', 'MEB'],
    isHighlighted: true,
    category: 'Etkinlik',
    faqs: [
      {
        question: 'TETZ 2025 Sonuç Raporunda ProgenX neden yer aldı?',
        answer: 'ProgenX, eğitim teknolojileri alanında geliştirdiği yenilikçi çözümler ve öğrenciler, öğretmenler ve kurumlar için sunduğu kapsayıcı eğitim teknolojisi platformu sayesinde TETZ 2025 Sonuç Raporunda yer almaya hak kazandı.'
      },
      {
        question: 'TETZ 2025 nedir?',
        answer: 'TETZ (Türkiye Eğitim Teknolojileri Zirvesi) 2025, Türkiye\'nin eğitim teknolojileri alanındaki en büyük ve prestijli zirvelerinden biridir. Cumhurbaşkanımız ve Millî Eğitim Bakanımızın katılımıyla gerçekleşen bu zirve, eğitimde dijital dönüşümü ele alan önemli bir platformdur.'
      }
    ]
  },
  {
    id: 'teknogirisim-rozeti-2025',
    slug: 'teknogirisim-rozeti-2025',
    title: 'Progenx Teknogirişim Rozeti\'ni Almaya Hak Kazandı!',
    date: '25 Temmuz 2025',
    excerpt: 'Progenx olarak, T.C. Sanayi ve Teknoloji Bakanlığı tarafından verilen Teknogirişim Rozeti\'ni almaya hak kazanan ilk girişimlerden biri olmanın gururunu yaşıyoruz.',
    content: `🏆 Gururla Paylaşıyoruz!
Progenx olarak, <strong>T.C. Sanayi ve Teknoloji Bakanlığı</strong> tarafından verilen <strong>Teknogirişim Rozeti</strong>'ni almaya hak kazanan ilk girişimlerden biri olmanın gururunu yaşıyoruz! 🎉

Bu rozet, teknoloji ve yenilik odaklı girişimlerin görünürlüğünü artırmayı, destek mekanizmalarına erişimini kolaylaştırmayı ve ekosistem içindeki konumunu güçlendirmeyi amaçlamaktadır.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Bu Rozet ile Hedeflerimiz:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Çözüm ve hizmetlerimizi daha ileri taşımak</li>
  <li style="margin-bottom: 10px;">• Teknoloji ekosisteminde güçlü konumumuzu pekiştirmek</li>
  <li style="margin-bottom: 10px;">• Yenilikçi projelerimizi daha geniş kitlelere ulaştırmak</li>
</ul>

Emeği geçen herkese teşekkür ederiz. 🤝`,
    images: [teknogirisimRozeti],
    links: [
      { text: 'LinkedIn\'de paylaşımı görüntüle', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7357022104770260992' }
    ],
    tags: ['Teknogirişim', 'Bakanlık', 'Ödül', 'Progenx'],
    isHighlighted: true,
    category: 'Ödül',
    faqs: [
      {
        question: 'Teknogirişim Rozeti nedir?',
        answer: 'Teknogirişim Rozeti, T.C. Sanayi ve Teknoloji Bakanlığı tarafından teknoloji ve yenilik odaklı girişimlerin görünürlüğünü artırmak, destek mekanizmalarına erişimini kolaylaştırmak ve ekosistem içindeki konumunu güçlendirmek amacıyla verilen bir rozettir.'
      },
      {
        question: 'ProgenX Teknogirişim Rozeti\'ni nasıl aldı?',
        answer: 'ProgenX, eğitim teknolojileri ve yapay zeka alanındaki yenilikçi çözümleri ve başarıları sayesinde Teknogirişim Rozeti\'ni almaya hak kazanan ilk girişimlerden biri oldu.'
      }
    ]
  },
  {
    id: 'aws-activate-2025',
    slug: 'aws-activate-programina-kabul-edildik',
    title: 'Progenx AWS Activate Programına Kabul Edildi!',
    date: '24 Temmuz 2025',
    excerpt: 'Progenx olarak AWS Activate programına kabul edildik. Bu önemli gelişme ile yapay zekâ tabanlı projelerimizi daha güçlü şekilde geliştirme fırsatı yakaladık.',
    content: `🚀 Büyük Haber!
Progenx resmi olarak <strong>AWS Activate</strong> programına dahil oldu! 🎉

Bu sayede, AWS'nin sunduğu teknik altyapı ve desteklerle yapay zekâ tabanlı projelerimizi daha güçlü şekilde geliştirme fırsatı yakaladık.

💡 AWS Activate program sağlayıcısı olan, MEB Yenilik ve Eğitim Teknolojileri Genel Müdürlüğü bünyesindeki <strong>ETKİM</strong> üzerinden yaptığımız başvuru sonucunda programa kabul edildik. 
Başvuru ve kabul sürecindeki desteğinden dolayı ETKİM ekibine ve bizi programa kabul eden AWS'ye teşekkür ederiz.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">🎯 Hedeflerimiz:</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Eğitim teknolojileri alanında yenilikçi çözümler sunmak</li>
  <li style="margin-bottom: 10px;">• Yeni nesil uygulamalar üretmek</li>
  <li style="margin-bottom: 10px;">• Yapay zekâ modelleri geliştirmek</li>
</ul>`,
    images: [awsActivate],
    links: [
      { text: 'LinkedIn\'de paylaşımı görüntüle', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7354095744628178944/?actorCompanyId=106101788' }
    ],
    tags: ['AWS', 'Activate', 'Yapay Zeka', 'Progenx', 'ETKİM'],
    isHighlighted: true,
    category: 'Program',
    faqs: [
      {
        question: 'AWS Activate programı nedir?',
        answer: 'AWS Activate, girişimlere AWS bulut altyapısı, teknik destek ve eğitim kaynakları sağlayan bir programdır. ProgenX, MEB ETKİM üzerinden başvurarak bu programa kabul edilmiştir.'
      },
      {
        question: 'AWS Activate programı ProgenX\'e ne sağlıyor?',
        answer: 'AWS Activate programı sayesinde ProgenX, yapay zeka tabanlı projelerini daha güçlü şekilde geliştirme, eğitim teknolojileri alanında yenilikçi çözümler sunma ve yeni nesil uygulamalar üretme fırsatı yakaladı.'
      }
    ]
  },
  {
    id: 'tetz-2025',
    slug: 'tetz-2025-te-gelecegi-birlikte-sekillendirdik',
    title: 'TETZ 2025\'te Geleceği Birlikte Şekillendirdik!',
    date: '29 Haziran 2025',
    excerpt: 'ProgenX olarak, 20-22 Haziran tarihleri arasında gerçekleştirilen Türkiye Eğitim Teknolojileri Zirvesi (TETZ 2025)\'te yer almaktan büyük bir gurur ve mutluluk duyuyoruz.',
    content: `Alanında Türkiye'nin en büyük ve en prestijli zirvelerinden biri olan bu etkinlik, Cumhurbaşkanımız <strong>Sayın Recep Tayyip Erdoğan</strong> ve Millî Eğitim Bakanımız <strong>Sayın Yusuf Tekin</strong>'in açılış konuşmalarıyla başladı. Zirve, eğitimde dijital dönüşümün ve yenilikçi teknolojilerin ele alındığı, ulusal ölçekte ses getiren bir platform oldu. <strong>ETKİM MEB</strong> bünyesinde katıldığımız zirvede eğitim teknolojileri alanındaki vizyonumuzu paylaşma fırsatı bulduk.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">3 Günlük Yoğun İlgi ve Etkileşim</h3>
Üç gün boyunca katılımcılar standımıza yoğun ilgi gösterdi.
Bakanlık temsilcileri, özel okul kurucuları, şirket CEO'ları, akademisyenler ve eğitim girişimcileri ile doğrudan temas kurarak, <strong>ProgenX</strong>'in sunduğu yapay zekâ destekli kişiselleştirilmiş öğrenme deneyimini tanıttık.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">Yeni Kullanıcılar, Yeni İş Birlikleri</h3>
<ul style="list-style-type: none; padding-left: 0;">
  <li style="margin-bottom: 10px;">• Ziyaretçilerimiz uygulamamızı birebir deneyimleme fırsatı buldu.</li>
  <li style="margin-bottom: 10px;">• Etkinlik sonunda <strong>500'ün üzerinde yeni kullanıcı</strong> platformumuza dahil oldu.</li>
  <li style="margin-bottom: 10px;">• Ayrıca birçok kurum ve eğitim kuruluşuyla iş birliği görüşmeleri için temas sağladık.</li>
  <li style="margin-bottom: 10px;">• Bazı bakanlık temsilcileriyle planlı toplantılar organize edildi ve yeni dönem için somut adımlar atıldı.</li>
</ul>

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">Eğitimde Dönüşüme Güç Katıyoruz</h3>
Standımızda gerçekleşen görüşmelerde aldığımız geri bildirimler, kullanıcı memnuniyeti ve artan indirme sayıları; geliştirdiğimiz teknolojinin sahada ne kadar güçlü bir karşılık bulduğunu bir kez daha kanıtladı.
Projenin kamu tarafındaki etkisi, yerli teknolojilerin eğitimdeki potansiyeli ve dijital öğrenmenin geleceği üzerine anlamlı sohbetler gerçekleştirdik.

<h3 style="color: var(--primary-color); margin: 25px 0 15px;">Teşekkür ve Gelecek Planlarımız</h3>
Başta <strong>Milli Eğitim Bakanlığı</strong> ve <strong>ETKİM MEB</strong> olmak üzere, bu büyük organizasyonu hayata geçiren tüm paydaşlara teşekkür ederiz.
Zirveye katılarak bizlerle tanışan, deneyimlerini paylaşan ve eğitimdeki dönüşüme katkı sunan tüm ziyaretçilerimize ayrıca minnettarız.

<div style="background-color: var(--light-bg); padding: 15px; border-radius: 8px; margin-top: 20px;">
<strong>Gelecek etkinliklerde yeniden görüşmek üzere!</strong>
Eğer TETZ'te bizlerle görüşme fırsatınız olmadıysa, dilediğiniz zaman bizimle iletişime geçebilir, platformumuzu daha yakından tanıyabilirsiniz.
</div>

Progenx Akademi olarak, Türkiye'nin dört bir yanındaki öğrencilere yenilikçi, etkili ve bireye özel bir öğrenme yolculuğu sunmak için çalışmaya devam ediyoruz.`,
    images: tetzImages,
    links: [
      { text: 'LinkedIn\'de paylaşımı görüntüle', url: 'https://www.linkedin.com/feed/update/urn:li:activity:7342211766212251648' }
    ],
    tags: ['TETZ2025', 'Eğitim Teknolojileri', 'Zirve', 'Progenx'],
    isHighlighted: true,
    category: 'Etkinlik'
  },
  {
    id: 'sosyal-sorumluluk-2025',
    slug: 'egitime-teknolojiyle-destek-sosyal-sorumluluk-adimi',
    title: 'Eğitime Teknolojiyle Destek: ProgenX\'den Sosyal Sorumluluk Adımı',
    date: '14 Nisan 2025',
    excerpt: '🌟 ProgenX, eğitimde geleceğe dokunuyor!',
    content: `Geçtiğimiz günlerde, HAVELSAN F5 Yönetici Gelişim Akademisi kapsamında, Hatay Naim Atakaş Anadolu Lisesi'nde öğrencilerle buluştuk. Bu anlamlı sosyal sorumluluk projesiyle, ProgenX olarak ürünümüzün beta sürümünü ücretsiz bir şekilde öğrencilerin kullanımına sunduk ve onların teknolojiye dair sorularını yanıtladık.

Öğrencilerle girdiğimiz etkileşim ve onların heyecanı bizi hem motive etti hem de eğitimin ve eğitimde yapay zeka kullanımının gücüne olan inancımızı pekiştirdi. Projemizle, onların öğrenme yolculuğuna katkı sağlamaktan gurur duyuyoruz.

Bu süreçte bize her anlamda destek olan ve liderlik eden Bürge Kılınç ve Berna Şimşek Cansız'a ve HAVELSAN ailesine teşekkür ederiz.

ProgenX olarak, sosyal ve kurumsal sorumluluk bilincimizle eğitime değer katmaya devam edeceğiz! 💡`,
    images: [],
    links: [],
    tags: ['Sosyal Sorumluluk', 'HAVELSAN', 'Eğitim', 'Progenx'],
    isHighlighted: false,
    category: 'Sosyal Sorumluluk'
  },
  {
    id: 'progenx-kurulus',
    slug: 'progenx-resmen-kuruldu',
    title: 'ProgenX Resmen Kuruldu!',
    date: '24 Aralık 2024',
    excerpt: 'Türkiye Ticaret Sicil Gazetesi\'nde tescil edilerek resmen kurulan ProgenX Eğitim ve Bilişim Teknolojileri A.Ş., eğitim teknolojileri, yazılım geliştirme ve yapay zeka danışmanlığı gibi alanlarda yenilikçi ve sürdürülebilir çözümler sunmak için yola çıkmıştır.',
    content: `Türkiye Ticaret Sicil Gazetesi'nde tescil edilerek resmen kurulan <strong>ProgenX Eğitim ve Bilişim Teknolojileri A.Ş.</strong>, eğitim teknolojileri, yazılım geliştirme ve yapay zeka danışmanlığı gibi alanlarda yenilikçi ve sürdürülebilir çözümler sunmak için yola çıkmıştır.

ProgenX olarak, Türkiye'nin dijital dönüşümüne katkı sağlamak ve eğitim alanında teknolojinin gücünü kullanarak öğrenme deneyimlerini zenginleştirmek misyonuyla hareket ediyoruz.`,
    images: [],
    links: [],
    tags: ['Kuruluş', 'Progenx', 'Şirket'],
    isHighlighted: false,
    category: 'Kurumsal'
  },
  {
    id: 'tubitak-mukemmeliyet-muhru',
    slug: 'tubitak-mukemmeliyet-muhru-odulu',
    title: 'TÜBİTAK Mükemmeliyet Mührü Ödülü',
    date: '15 Aralık 2024',
    excerpt: 'ProgenX, HAVELSAN danışmanlığında yürütülen çalışmalar sonucunda 1812 - Yatırım Tabanlı Girişimcilik Destek Programı (BiGG Yatırım) desteğiyle TÜBİTAK Mükemmeliyet Mührü gibi önemli bir ödüle layık görüldü.',
    content: `ProgenX, <strong>HAVELSAN</strong> danışmanlığında yürütülen çalışmalar sonucunda <strong>1812 - Yatırım Tabanlı Girişimcilik Destek Programı (BiGG Yatırım)</strong> desteğiyle <strong>TÜBİTAK Mükemmeliyet Mührü</strong> gibi önemli bir ödüle layık görüldü.

Bu ödül, ProgenX'in teknoloji ve yenilik alanındaki başarısını ve potansiyelini resmi olarak tanıyan önemli bir adımdır. TÜBİTAK'ın bu değerli ödülü, şirketimizin gelecekteki projeleri için önemli bir motivasyon kaynağıdır.

HAVELSAN'a danışmanlık desteği için teşekkür ederiz.`,
    images: [],
    links: [],
    tags: ['TÜBİTAK', 'Mükemmeliyet Mührü', 'Ödül', 'HAVELSAN', 'Progenx'],
    isHighlighted: false,
    category: 'Ödül'
  }
];

// Helper function to get announcement by slug
export const getAnnouncementBySlug = (slug) => {
  return announcements.find(announcement => announcement.slug === slug);
};

// Helper function to get all announcement slugs
export const getAllAnnouncementSlugs = () => {
  return announcements.map(announcement => announcement.slug);
};
